// eslint-disable-next-line no-restricted-imports
import moment from 'moment-timezone';

moment.locale('en');

export default moment;
